import {
    Stack,
    Switch,
    Text,
    Collapse,
    Button,
    Divider,
    Box,
    TextInput,
} from "@mantine/core";
import { useSettingsFormContext } from "./SettingsForm";
import ReminderConfigItem from "./ReminderConfigItem";
import { useParams } from "react-router-dom";
import React from "react";
import { useBoundStore } from "../../store";
import { randomId } from "@mantine/hooks";

interface CommunicationsFormProps {}

const CommunicationsForm = (props: CommunicationsFormProps) => {
    const form = useSettingsFormContext();
    const params = useParams<{ id: string }>();

    const { configurations } = useBoundStore();

    // Fetch configs for the customer in this hook
    React.useEffect(() => {
        form.setFieldValue("configurations", configurations || []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id]);

    React.useEffect(() => {
        if (
            configurations.length === 0 &&
            form.values.isCommunicationsEnabled
        ) {
            form.insertListItem("configurations", {
                key: randomId(),
                id: randomId(),
                sms_message: "",
                schedule_days: 0,
                email_template: "",
                email_template_model: {
                    subject: "",
                    heading: "",
                    cta: "",
                    message: "",
                },
            });
        }
        if (form.values.isCommunicationsEnabled === false) {
            form.setFieldValue("configurations", []);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form.values.isCommunicationsEnabled]);

    return (
        <Stack>
            <Text fz="sm" fw={500} mb="-10px">
                Enable Communications
            </Text>
            <Switch
                onLabel={<Text fz="sm">Enabled</Text>}
                offLabel={<Text fz="sm">Disabled</Text>}
                size="lg"
                {...form.getInputProps("isCommunicationsEnabled", {
                    type: "checkbox",
                })}
                data-qa="customerSettings_isCommunicationsEnabledField"
            />
            <Collapse in={form.values.isCommunicationsEnabled}>
                <Box sx={{ position: "relative", minHeight: 100 }}>
                    <TextInput
                        w={400}
                        label="SMS and Email Sender Name (max 11 characters)"
                        placeholder="SMS and Email Sender"
                        radius="md"
                        withAsterisk
                        {...form.getInputProps(`smsSender`)}
                        data-qa="customerSettings_smsSenderField"
                    />

                    {form.values?.configurations?.map((config, index) => (
                        <Box key={config.id} pt="md">
                            <ReminderConfigItem
                                handleDelete={() =>
                                    form.removeListItem("configurations", index)
                                }
                                position={index}
                            />
                        </Box>
                    ))}
                    <Divider
                        labelPosition="center"
                        pt="lg"
                        pb="md"
                        label={
                            <Button
                                ml={5}
                                onClick={() =>
                                    form.insertListItem("configurations", {
                                        key: randomId(),
                                        id: randomId(),
                                        sms_message: "",
                                        schedule_days: 0,
                                        email_template: "",
                                        email_template_model: {
                                            subject: "",
                                            heading: "",
                                            cta: "",
                                            message: "",
                                        },
                                    })
                                }
                                disabled={
                                    (form?.values?.configurations?.length ??
                                        0) >= 10
                                }
                            >
                                Add Reminder
                            </Button>
                        }
                    />
                </Box>
            </Collapse>
        </Stack>
    );
};

export default CommunicationsForm;
